import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {AsyncPipe, isPlatformBrowser, NgIf, NgStyle} from '@angular/common';
import {AbydosConfigService, FetchRequest, FetchRequestWithDelay, RestService} from '@abydos-angular/core';
import {tap} from 'rxjs/operators';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {
    AuthConfigService,
    AuthFacade,
    AuthInfoState,
    AuthRepository,
    CategoryFacade, versionInfoResultAction,
} from '@abydos-angular/rest-api';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {Store} from '@ngrx/store';
import {ButtonDirective} from 'primeng/button';
import {SpeedDial} from 'primeng/speeddial';
import {PrimeNGServiceHandlerComponent} from './primeng-service-handler/primeng-service-handler.component';
import {TerminateOnFirstExecutor} from '@abydos-angular/store';
import {EnvironmentInjectionToken} from './app.config';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, NgStyle, PrimeNGServiceHandlerComponent, AsyncPipe, ButtonDirective, SpeedDial, PrimeNGServiceHandlerComponent, NgIf],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    standalone: true,
})
export class AppComponent implements OnInit {
    environment = inject(EnvironmentInjectionToken);
    title = 'unideb-booking-frontend';
    currentUserInfo: any;
    profileOptions: any[] = [
        {label: 'Kijelentkezés', icon: 'pi pi-sign-out', command: () => this.logout()},
    ]
    versionInfoObserver = this.authFacade.backendVersionInfo;
    private platformId = inject(PLATFORM_ID);
    isBrowser = isPlatformBrowser(this.platformId);

    public list = this.categoryFacade.listData.pipe(tap(restResponse => {
        this.abydosConfigService.getErrorHandler().info(restResponse.getFirstData()?.name);
    }), takeUntilDestroyed()).subscribe();
    public isUserLoggedIn = this.authFacade.isUserLoggedIn;

    constructor(private router: Router, private restService: RestService, private abydosConfigService: AbydosConfigService, private categoryFacade: CategoryFacade,
                private authFacade: AuthFacade, private authConfigService: AuthConfigService, private appStore: Store,
                private authRepository: AuthRepository, private authStore: Store<AuthInfoState>) {
        this.authFacade.loadStoredAuthInfo();
        this.authFacade.userInfo.pipe(takeUntilDestroyed()).subscribe(value => {
            this.currentUserInfo = value
            const newRoute = this.authConfigService.getAuthConfig().onRouteWithRole!(this.currentUserInfo.selectedRole, this.authFacade);
            if (isNotNullOrUndefined(newRoute)) {
                this.router.navigateByUrl(newRoute).then();
            }
        });
    }

    logoClicked() {
        this.router.navigateByUrl('landing').then()
    }

    ngOnInit(): void {
        if ( this.isBrowser ) {
            new TerminateOnFirstExecutor(versionInfo => {
                this.authStore.dispatch(versionInfoResultAction({ payload: versionInfo }));
            }).run(this.authRepository.getVersions(true));
        }
    }

    logout() {
        this.authFacade.logout();
    }

    navigateToLogin() {
        this.router.navigateByUrl('login').then();
    }

    openDocument() {
        window.open( this.environment.documentDisplayUrl + '/Public/DEKOKK%20-%20Hallgatói%20kézikönyv.pdf', '_blank');
    }
}
